export const HeroBanner = (banners) => {
    if (!banners || banners.length === 0) return document.createElement('div');

    const bannerContainer = document.createElement('div');
    // Maintain exact styling from home.js but remove external margin
    // [FIX] Removed mb-8
    bannerContainer.className = "rounded-xl overflow-hidden shadow-lg relative aspect-video md:aspect-[21/9] group bg-gray-900";

    // 1. Render Slides
    const slideHTML = banners.map((b, idx) => `
        <div class="absolute inset-0 transition-opacity duration-700 ease-in-out ${idx === 0 ? 'opacity-100 z-10' : 'opacity-0 z-0'} banner-slide" data-index="${idx}">
            <img src="${b.imageUrl}" class="w-full h-full object-cover" alt="${b.title || 'Banner'}">
            <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex flex-col justify-end p-6">
                ${b.linkUrl ? `<button class="self-start px-4 py-2 bg-white/20 backdrop-blur-md border border-white/50 text-white rounded-lg font-bold hover:bg-white hover:text-black transition-all" onclick="window.router.navigate('${b.linkUrl}')">View More</button>` : ''}
            </div>
            ${b._eventBadge ? `
                <div class="absolute top-4 left-4 bg-yellow-400 text-red-900 px-3 py-1.5 rounded-lg shadow-lg z-20 font-black flex items-center gap-2 animate-bounce-in">
                    <span class="material-symbols-outlined fill-current text-sm">bolt</span> 
                    <span>${b._eventBadge}</span>
                </div>
            ` : ''}
        </div>
    `).join('');

    // 2. Render Indicators
    const dotsHTML = `
        <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
            ${banners.map((_, idx) => `<div class="w-2 h-2 rounded-full bg-white/50 cursor-pointer banner-dot ${idx === 0 ? 'bg-white w-6' : ''}" data-index="${idx}"></div>`).join('')}
        </div>
    `;

    bannerContainer.innerHTML = slideHTML + dotsHTML;

    // 3. Slider Logic (Auto-play)
    if (banners.length > 1) {
        let currentSlide = 0;
        const slides = bannerContainer.querySelectorAll('.banner-slide');
        const dots = bannerContainer.querySelectorAll('.banner-dot');
        let interval = null;

        const showSlide = (idx) => {
            slides.forEach((s, i) => {
                s.style.opacity = i === idx ? '1' : '0';
                s.style.zIndex = i === idx ? '10' : '0';
            });
            dots.forEach((d, i) => {
                d.className = `w-2 h-2 rounded-full cursor-pointer banner-dot transition-all ${i === idx ? 'bg-white w-6' : 'bg-white/50'}`;
            });
            currentSlide = idx;
        };

        const nextSlide = () => {
            showSlide((currentSlide + 1) % banners.length);
        };

        interval = setInterval(nextSlide, 5000);

        // Interaction pauses auto-play? Optional. 
        // For now, simple implementation like original.

        // Manual Navigation
        dots.forEach((dot, idx) => {
            dot.onclick = () => {
                clearInterval(interval);
                showSlide(idx);
                interval = setInterval(nextSlide, 5000); // Restart timer
            };
        });

        // Cleanup on remove? 
        // Not easily possible with vanilla JS element return unless we attach method.
        // We can attach `destroy` method to element.
        bannerContainer.destroy = () => clearInterval(interval);
    }

    return bannerContainer;
};
